<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IuYY3H/tc-custom/9780061970009.jpg?1730585177917" alt="This image is the cover for the book Fires of Jubilee"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fires of Jubilee
      </h1>
      <p class="bookDescription body article font2">
        <b>“A penetrating reconstruction of the most disturbing and crucial slave uprising in America’s history”—with the full text of The Confessions of Nat Turner (<i>New York Times</i>).</b><br/><br/>In August of 1831, the enslaved carpenter and preacher Nat Turner led an anti-slavery uprising in Virginia. It lasted several days before state militias captured Turner and put him on trial. Before he was executed, Turner recounted the unbearable conditions he endured and how he secretly built support for his cause over many years. Turner’s Rebellion, and the savage reprisals that followed, shattered longstanding myths of the contented slave and the benign master.<br/><br/>Turner’s story and tactics also inspired the abolitionist movement, intensifying the forces of change that would plunge America into Civil War. Stephen B. Oates, the celebrated biographer of Abraham Lincoln and Martin Luther King, Jr., presents a gripping and insightful narrative of the rebellion—the complex, gifted, and driven man who led it, the social conditions that produced it, and the legacy it left. <br/><br/><i>The Fires of Jubilee</i> is a classic wok of American history. This new edition includes the text of the original 1831 court document "The Confessions of Nat Turner."
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen B. Oates
      </h2>
      
      <p class="authorDescription body article"><P>Stephen B. Oates (1936-2021) was a professor emeritus of history at the University of Massachusetts&#8211;Amherst. His books include <I>Let the Trumpet Sound: A Life of Martin Luther King, Jr.</I> and <I>With Malice Toward None: A Life of Abraham Lincoln</I>. Oates has been awarded numerous honors, including a Guggenheim Fellowship, Robert F. Kennedy Book Award, and Nevins-Freeman Award of the Civil War Round Table of Chicago for lifetime achievement in the field of Civil War studies.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4871a02c